import { render, staticRenderFns } from "./server-set-security-group.vue?vue&type=template&id=1a37de63&scoped=true&"
import script from "./server-set-security-group.vue?vue&type=script&lang=js&"
export * from "./server-set-security-group.vue?vue&type=script&lang=js&"
import style0 from "./server-set-security-group.vue?vue&type=style&index=0&id=1a37de63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a37de63",
  null
  
)

export default component.exports